module.exports = __webpack_public_path__ + "static/media/blockchain-management.d7f3cab3.svg";